
//Button.js

import React, { useState } from 'react';
import styles from '../css/button.module.css';

const Button = ({ children, onClick, btnColor, labelColor, btnBgColor, btnFontColor, disabled, type, style, ...props }) => {
	const [
		hover,
		setHover
	] = useState(false);
	const toggleHover = () => {
		setHover(!hover);
	};
	const commonStyles = {
		backgroundColor : btnColor,
		color           : labelColor || 'white'
	};
	const outlineStyles = {
		border          : `2px solid ${btnColor}`,
		color           : btnFontColor,
		//backgroundColor : 'white'
		backgroundColor : btnBgColor,
		width  : '100%'
	};
	const outlineHoverStyle = {
		color           : labelColor || 'white',
		backgroundColor : btnColor,
		width  : '100%'
	};

	const roundedStyle = {
		backgroundColor : btnColor,
		color           : labelColor || 'white',
		borderRadius    : '25px'
	};
	const disabledStyle = {
		cursor          : 'default',
		backgroundColor : btnColor,
		color           : labelColor || 'white',
		opacity         : 0.4
	};
	const blockStyles = {
		width  : '100%',
		margin : '0 auto'
	};

	let btnStyle;
	switch (type) {
		case 'rounded':
			btnStyle = roundedStyle;
			break;
		case 'block':
			btnStyle = blockStyles;
			break;
		case 'outline':
			if (hover) {
				btnStyle = outlineHoverStyle;
			}
			else {
				btnStyle = outlineStyles;
			}
			break;
		default:
			btnStyle = {
				backgroundColor : btnColor,
				color           : labelColor || 'white'
			};
			break;
	}
	return (
		<button
			style={

					disabled ? { ...commonStyles, ...btnStyle, ...disabledStyle, ...style } :
					{ ...commonStyles, ...btnStyle, ...style }
			}
			onMouseEnter={toggleHover}
			onMouseLeave={toggleHover}
			{...props}
			type="button"
			onClick={

					!disabled ? onClick :
					() => {}
			}
			className={styles.btn}
		>
			{children || 'button'}
		</button>
	);
};

export default Button;